import React from "react";
import styles from "./StatisticsSkeleton.module.scss";

const StatisticsSkeleton: React.FC = () => {
  return (
    <div className="container mt-4">
      <h1 className={styles.skeletonHeader}></h1>
      <div className={styles.searchSkeleton}></div>

      <div className={styles.tableSkeleton}>
        {[...Array(5)].map((_, rowIndex) => (
          <div key={rowIndex} className={styles.tableRow}>
            {[...Array(4)].map((_, cellIndex) => (
              <div key={cellIndex} className={styles.tableCell}></div>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};

export default StatisticsSkeleton;
